import {
  getStorageMaterial,
  getStorageInstrument,
  deleteStorageMaterial,
  updateStorageMaterial,
  createStorageMaterial,
  createStorageInstrument,
} from '@/api/storage'

export default {
  FETCH_STORAGE_MATERIAL({ commit }, params) {
    return new Promise((resolve, reject) => {
      getStorageMaterial(params)
        .then(response => {
          commit('SET_STORAGE_MATERIAL', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  CREATE_STORAGE_MATERIAL(_, data) {
    return createStorageMaterial(data)
  },

  UPDATE_STORAGE_MATERIAL(_, data) {
    return updateStorageMaterial(data)
  },

  DELETE_STORAGE_MATERIAL(_, id) {
    return deleteStorageMaterial(id)
  },

  FETCH_STORAGE_INSTRUMENT({ commit }, params) {
    return getStorageInstrument(params)
      .then(res => {
        commit('SET_STORAGE_INSTRUMENT', res.data)
      })
  },

  CREATE_STORAGE_INSTRUMENT(_, data) {
    return createStorageInstrument(data)
  },
}
